"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3907],{

/***/ 3907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AppLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/antd/es/layout/index.js + 2 modules
var layout = __webpack_require__(63586);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/common/components/contexts/firebaseApp.tsx + 1 modules
var contexts_firebaseApp = __webpack_require__(74878);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(40794);
// EXTERNAL MODULE: ../../libs/data-access/src/index.ts + 57 modules
var src = __webpack_require__(97967);
// EXTERNAL MODULE: ../../node_modules/antd/es/button/index.js + 41 modules
var es_button = __webpack_require__(25663);
// EXTERNAL MODULE: ../../node_modules/antd/es/modal/index.js + 1 modules
var modal = __webpack_require__(77423);
// EXTERNAL MODULE: ../../node_modules/antd/es/segmented/index.js + 11 modules
var segmented = __webpack_require__(44345);
// EXTERNAL MODULE: ../../node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(72396);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(79864);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
// EXTERNAL MODULE: ../../node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(76219);
// EXTERNAL MODULE: ../../node_modules/antd/es/empty/index.js + 3 modules
var empty = __webpack_require__(77813);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/CloseCircleOutlined.js + 1 modules
var CloseCircleOutlined = __webpack_require__(7325);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ../../libs/shared/ui/src/index.ts + 240 modules
var ui_src = __webpack_require__(3592);
// EXTERNAL MODULE: ../../node_modules/antd/es/app/index.js + 51 modules
var app = __webpack_require__(19509);
// EXTERNAL MODULE: ../../node_modules/antd/es/form/index.js + 21 modules
var es_form = __webpack_require__(90685);
// EXTERNAL MODULE: ../../node_modules/antd/es/input/index.js + 6 modules
var input = __webpack_require__(15734);
// EXTERNAL MODULE: ../../node_modules/antd/es/select/index.js
var es_select = __webpack_require__(51747);
;// CONCATENATED MODULE: ./src/features/showcase/edit/index.tsx








const showcaseLabelOptions = [
    {
        label: "Company",
        value: "COMPANY"
    },
    {
        label: "Post",
        value: "POST"
    },
    {
        label: "Open Challenge",
        value: "OPEN_CHALLENGE"
    },
    {
        label: "Intra-Challenge",
        value: "INTRA_CHALLENGE"
    },
    {
        label: "Pitch",
        value: "PITCH"
    },
    {
        label: "Idea",
        value: "IDEA"
    },
    {
        label: "POC",
        value: "POC"
    }
];
function ShowcaseEdit(param) {
    let { showcaseId , showcaseType , onFinish , onCancel  } = param;
    const { notification  } = app/* default.useApp */.Z.useApp();
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [form] = es_form/* default.useForm */.Z.useForm();
    const [getData, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_SHOWCASE_BY_ID */.dCX, {
        variables: {
            id: showcaseId
        }
    });
    const handleCompleted = ()=>{
        form.resetFields();
        onFinish();
        notification.success({
            message: showcaseId ? tcommon("update_success") : tcommon("create_success")
        });
    };
    const handleError = (error)=>{
        notification.error({
            message: t("error_updating_post_status"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-red-600",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseCircleOutlined/* default */.Z, {})
            })
        });
    };
    const [createShowcase, { loading: createLoading  }] = (0,useMutation/* useMutation */.D)(src/* CREATE_SHOWCASE */.d2p, {
        onCompleted: handleCompleted,
        onError: handleError,
        refetchQueries: [
            {
                query: src/* GET_SHOWCASES */.MW5,
                variables: {
                    types: [
                        showcaseType
                    ]
                }
            }
        ]
    });
    const [patchShowcase, { loading: patchLoading  }] = (0,useMutation/* useMutation */.D)(src/* PATCH_SHOWCASE */.mL3, {
        onCompleted: handleCompleted,
        onError: handleError
    });
    const handleFormChange = ()=>{
    //
    };
    const handleOnFinish = (values)=>{
        if (showcaseId) {
            patchShowcase({
                variables: {
                    input: {
                        id: showcaseId,
                        type: showcaseType,
                        ...values
                    }
                }
            });
        } else {
            createShowcase({
                variables: {
                    input: {
                        type: showcaseType,
                        ...values
                    }
                }
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.showcase) {
            form.setFieldsValue({
                title: data.showcase.title,
                description: data.showcase.description,
                label: data.showcase.label,
                bannerData: data.showcase.banner,
                link: data.showcase.link,
                buttonName: data.showcase.buttonName
            });
        }
    }, [
        data,
        form
    ]);
    (0,react.useEffect)(()=>{
        if (showcaseId) {
            getData();
        }
    }, [
        getData,
        showcaseId
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-6 text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
            form: form,
            layout: "vertical",
            onFieldsChange: handleFormChange,
            onFinish: handleOnFinish,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    label: t("showcase_title"),
                    name: "title",
                    rules: [
                        {
                            required: true,
                            message: t("input_required_message")
                        }
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                        placeholder: t("showcase_title_placeholder"),
                        "data-test": "showcase-title-input"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    label: t("showcase_description"),
                    name: "description",
                    rules: [
                        {
                            required: true,
                            message: t("input_required_message")
                        }
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default.TextArea */.Z.TextArea, {
                        rows: 4,
                        placeholder: t("showcase_description_placeholder"),
                        "data-test": "showcase-description-input"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    label: t("showcase_label"),
                    name: "label",
                    rules: [
                        {
                            required: true,
                            message: t("select_required_message")
                        }
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                        options: showcaseLabelOptions,
                        placeholder: t("showcase_label_placeholder"),
                        "data-test": "showcase-label-select"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    label: t("showcase_banner"),
                    name: "bannerData",
                    rules: [
                        {
                            required: true,
                            message: t("upload_image_required")
                        }
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* ImageUpload */.Ur, {
                        title: tcommon("upload_image_title"),
                        description: tcommon("recommended_image_size", {
                            size: "1600x900",
                            formats: "jpeg, jpg, png"
                        }),
                        crop: {
                            quality: 0.8,
                            aspect: 160 / 90,
                            minZoom: 1,
                            maxZoom: 10
                        },
                        onUploadSuccess: (file)=>form.setFieldValue("bannerData", file),
                        "data-test": "showcase-banner-upload"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    label: t("showcase_link"),
                    name: "link",
                    rules: [
                        {
                            required: true,
                            message: t("input_required_message")
                        }
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                        placeholder: t("paste_your_link"),
                        "data-test": "showcase-link-input"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                    label: t("showcase_button_name"),
                    name: "buttonName",
                    rules: [
                        {
                            required: true,
                            message: t("input_required_message")
                        }
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                        placeholder: t("showcase_button_name_placeholder"),
                        "data-test": "showcase-button-name-input"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-end items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                            shape: "round",
                            onClick: ()=>onCancel(),
                            "data-test": "showcase-cancel-btn",
                            children: tcommon("cancel")
                        }, "back"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                            type: "primary",
                            shape: "round",
                            loading: createLoading || patchLoading,
                            htmlType: "submit",
                            "data-test": "showcase-save-btn",
                            children: tcommon("save")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var edit = (ShowcaseEdit);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/TeamOutlined.js + 1 modules
var TeamOutlined = __webpack_require__(90213);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/ReadOutlined.js + 1 modules
var ReadOutlined = __webpack_require__(65695);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/RocketOutlined.js + 1 modules
var RocketOutlined = __webpack_require__(72481);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/BulbOutlined.js + 1 modules
var BulbOutlined = __webpack_require__(59271);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/VideoCameraOutlined.js + 1 modules
var VideoCameraOutlined = __webpack_require__(87998);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/FireOutlined.js + 1 modules
var FireOutlined = __webpack_require__(52663);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/CodeSandboxOutlined.js + 1 modules
var CodeSandboxOutlined = __webpack_require__(72077);
// EXTERNAL MODULE: ../../libs/shared/util/src/index.ts + 8 modules
var util_src = __webpack_require__(12105);
// EXTERNAL MODULE: ../../node_modules/antd/es/image/index.js + 41 modules
var es_image = __webpack_require__(93614);
// EXTERNAL MODULE: ../../node_modules/antd/es/popconfirm/index.js + 2 modules
var popconfirm = __webpack_require__(26563);
;// CONCATENATED MODULE: ./src/features/showcase/list/card.tsx









const getIcon = (key)=>{
    switch(key){
        case "COMPANY":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamOutlined/* default */.Z, {});
        case "POST":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadOutlined/* default */.Z, {});
        case "OPEN_CHALLENGE":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RocketOutlined/* default */.Z, {});
        case "INTRA_CHALLENGE":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BulbOutlined/* default */.Z, {});
        case "PITCH":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCameraOutlined/* default */.Z, {});
        case "IDEA":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FireOutlined/* default */.Z, {});
        case "POC":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeSandboxOutlined/* default */.Z, {});
        default:
            break;
    }
};
function CompanyShowcaseCard(param) {
    let { data  } = param;
    const { notification  } = app/* default.useApp */.Z.useApp();
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const [isOpenModal, setIsOpenModal] = (0,react.useState)(false);
    const handleCompleted = ()=>{
        notification.success({
            message: tcommon("remove_success")
        });
    };
    const [deleteShowcase, { loading: deleteLoading  }] = (0,useMutation/* useMutation */.D)(src/* REMOVE_SHOWCASE */.OiY, {
        onCompleted: handleCompleted,
        refetchQueries: [
            {
                query: src/* GET_SHOWCASES */.MW5,
                variables: {
                    types: [
                        data.type
                    ]
                }
            }
        ]
    });
    const handleOpenModal = ()=>{
        setIsOpenModal(!isOpenModal);
    };
    const handleRemove = ()=>{
        deleteShowcase({
            variables: {
                id: data.id
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-4 rounded-lg bg-gray-200 flex gap-4",
        "data-test": "showcase-card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_image/* default */.Z, {
                    src: data.banner.url,
                    alt: data.title,
                    preview: false,
                    height: 60,
                    width: 100,
                    className: "rounded-md"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm text-gray-900 font-semibold",
                        children: data.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs text-gray-700 line-clamp-2 font-normal",
                        children: data.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col justify-center w-28",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "w-full text-xs text-gray-900 font-normal flex gap-1 items-center",
                    children: [
                        getIcon(data.label),
                        (0,util_src/* getLinkLabel */.en)(data.label.toLowerCase())
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                        type: "link",
                        onClick: handleOpenModal,
                        "data-test": "showcase-edit-btn",
                        children: tcommon("edit")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popconfirm/* default */.Z, {
                        title: t("showcase_delete_confirm"),
                        okButtonProps: {
                            loading: deleteLoading
                        },
                        onConfirm: handleRemove,
                        okText: tcommon("yes"),
                        cancelText: tcommon("no"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                            type: "link",
                            danger: true,
                            "data-test": "showcase-delete-btn",
                            children: tcommon("delete")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                title: t("edit_showcase"),
                open: isOpenModal,
                onCancel: handleOpenModal,
                footer: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(edit, {
                    showcaseId: data === null || data === void 0 ? void 0 : data.id,
                    showcaseType: data === null || data === void 0 ? void 0 : data.type,
                    onFinish: handleOpenModal,
                    onCancel: handleOpenModal
                })
            })
        ]
    });
}
/* harmony default export */ var card = (CompanyShowcaseCard);

;// CONCATENATED MODULE: ./src/features/showcase/list/index.tsx









function CompanyShowcaseList(param) {
    let { type  } = param;
    var ref;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [isOpenModal, setIsOpenModal] = (0,react.useState)(false);
    const [getData, { data , loading  }] = (0,useLazyQuery/* useLazyQuery */.t)(src/* GET_SHOWCASES */.MW5);
    const handleOpenModal = ()=>{
        setIsOpenModal(!isOpenModal);
    };
    const AddButton = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
            type: "primary",
            shape: "round",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusOutlined/* default */.Z, {}),
            onClick: handleOpenModal,
            "data-test": "showcase-create-btn",
            children: t("add_new_showcase")
        });
    };
    (0,react.useEffect)(()=>{
        if (type) {
            getData({
                variables: {
                    types: [
                        type
                    ]
                }
            });
        }
    }, [
        getData,
        type
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-6 text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-3 space-y-2",
        children: [
            (data === null || data === void 0 ? void 0 : (ref = data.showcases) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddButton, {})
                    }),
                    data === null || data === void 0 ? void 0 : data.showcases.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(card, {
                            data: item
                        }, index))
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* default */.Z, {
                        image: empty/* default.PRESENTED_IMAGE_SIMPLE */.Z.PRESENTED_IMAGE_SIMPLE
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                title: t("add_showcase"),
                open: isOpenModal,
                onCancel: handleOpenModal,
                footer: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(edit, {
                    showcaseType: type,
                    onFinish: handleOpenModal,
                    onCancel: handleOpenModal
                })
            })
        ]
    });
}
/* harmony default export */ var list = (CompanyShowcaseList);

;// CONCATENATED MODULE: ./src/features/showcase/index.tsx







function ShowcaseMenu() {
    var ref;
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const [isOpenModal, setIsOpenModal] = (0,react.useState)(false);
    const [segmentMode, setSegmentMode] = (0,react.useState)("BRIDGE");
    const { data: meData  } = (0,useQuery/* useQuery */.a)(src/* GET_ME */.xFT);
    const handleOpenModal = ()=>{
        setIsOpenModal(!isOpenModal);
    };
    const handleSegmentMode = (value)=>{
        setSegmentMode(value);
    };
    if ((meData === null || meData === void 0 ? void 0 : (ref = meData.me) === null || ref === void 0 ? void 0 : ref.role) !== "ADMIN") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                shape: "round",
                onClick: handleOpenModal,
                "data-test": "showcase-edit-btn",
                children: t("edit_showcase")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                title: t("edit_showcase"),
                open: isOpenModal,
                onCancel: handleOpenModal,
                width: 750,
                footer: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(segmented/* default */.Z, {
                            rootClassName: "overflow-x-auto",
                            defaultValue: segmentMode,
                            options: [
                                {
                                    label: t("bridge_carousel"),
                                    value: "BRIDGE"
                                },
                                {
                                    label: t("innovation_carousel"),
                                    value: "INNOVATION"
                                }
                            ],
                            block: true,
                            onChange: handleSegmentMode
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(list, {
                            type: segmentMode
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var showcase = (ShowcaseMenu);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/SwapOutlined.js + 1 modules
var SwapOutlined = __webpack_require__(19305);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/features/switcher/index.tsx








const PLATFORM_URL = ("https://demo.openalliance.and.global" || 0) + ("/fintechbridge" || 0);
const Switcher = ()=>{
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const { data  } = (0,useQuery/* useQuery */.a)(src/* GET_ME */.xFT);
    if ((data === null || data === void 0 ? void 0 : data.me.role) === "ADMIN" || (0,src/* checkPermission */.P_w)(data === null || data === void 0 ? void 0 : data.me, [
        src/* PERMISSIONS.INTERNAL_CHALLENGE_MANAGEMENT */._IT.INTERNAL_CHALLENGE_MANAGEMENT,
        src/* PERMISSIONS.OPEN_CHALLENGE_MANAGEMENT */._IT.OPEN_CHALLENGE_MANAGEMENT,
        src/* PERMISSIONS.A3_MANAGER */._IT.A3_MANAGER,
        src/* PERMISSIONS.COMMUNITY_MANAGER */._IT.COMMUNITY_MANAGER
    ])) return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: PLATFORM_URL,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
            type: "primary",
            size: "middle",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapOutlined/* default */.Z, {}),
            shape: "round",
            "data-test": "switch-to-user-btn",
            children: tcommon("switch_to_user")
        })
    });
    else return null;
};
/* harmony default export */ var switcher = (Switcher);

// EXTERNAL MODULE: ./src/features/user/index.ts + 1 modules
var features_user = __webpack_require__(80348);
// EXTERNAL MODULE: ./src/settings/hooks.ts
var hooks = __webpack_require__(3058);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(56675);
// EXTERNAL MODULE: ../../libs/notification/src/index.ts + 9 modules
var notification_src = __webpack_require__(51632);
// EXTERNAL MODULE: ../../node_modules/antd/es/dropdown/index.js + 5 modules
var dropdown = __webpack_require__(88701);
// EXTERNAL MODULE: ../../node_modules/antd/es/avatar/index.js + 4 modules
var avatar = __webpack_require__(3409);
// EXTERNAL MODULE: ../../node_modules/firebase/auth/dist/esm/index.esm.js + 1 modules
var index_esm = __webpack_require__(18325);
;// CONCATENATED MODULE: ./src/common/components/AppLayout/Header/index.tsx













const Header = ()=>{
    var ref, ref1, ref2, ref3;
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const client = (0,useApolloClient/* useApolloClient */.x)();
    const dispatch = (0,hooks/* useAppDispatch */.TL)();
    const firebaseUser = (0,hooks/* useAppSelector */.CG)(features_user/* selectFirebaseUUID */.SE);
    const { data  } = (0,useQuery/* useQuery */.a)(src/* GET_ME */.xFT);
    const firebaseApp = (0,contexts_firebaseApp/* useFirebaseApp */.$)();
    const items = [
        {
            key: "1",
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "!text-red-500",
                onClick: ()=>logout(),
                children: tcommon("logout")
            })
        }
    ];
    const logout = async ()=>{
        try {
            const response = await (0,src/* signOut */.w73)();
            if (response) {
                await client.clearStore();
                window.location.reload();
            }
        } catch (error) {
            console.log("logout error: ", error);
        }
    };
    const { data: meData  } = (0,useQuery/* useQuery */.a)(src/* GET_ME */.xFT);
    const fetchToken = (0,react.useCallback)(async ()=>{
        try {
            const auth = (0,index_esm/* getAuth */.v0)();
            const userCredential = await (0,index_esm/* signInWithCustomToken */._p)(auth, "".concat(meData === null || meData === void 0 ? void 0 : meData.me.authToken));
            const user = userCredential.user;
            dispatch((0,features_user/* setFirebaseUUID */.zc)(user === null || user === void 0 ? void 0 : user.uid));
        } catch (error) {
            console.log("Firebase auth error");
        }
    }, [
        meData,
        dispatch
    ]);
    (0,react.useEffect)(()=>{
        fetchToken();
    }, [
        fetchToken
    ]);
    const isAdmin = (0,react.useMemo)(()=>{
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.role) === "ADMIN";
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.role
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default.Header */.Z.Header, {
        className: "flex items-center justify-end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher, {}),
                isAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(showcase, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_src/* NotificationBell */.LE, {
                    firebaseUser: firebaseUser,
                    firebaseApp: firebaseApp
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                    menu: {
                        items
                    },
                    trigger: [
                        "click"
                    ],
                    placement: "topLeft",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                        size: 32,
                        className: "!cursor-pointer",
                        src: data === null || data === void 0 ? void 0 : (ref1 = data.me) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.url,
                        children: data === null || data === void 0 ? void 0 : (ref3 = data.me) === null || ref3 === void 0 ? void 0 : ref3.fullName.charAt(0)
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AppLayout_Header = (Header);

// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/DashboardOutlined.js + 1 modules
var DashboardOutlined = __webpack_require__(16767);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/BlockOutlined.js + 1 modules
var BlockOutlined = __webpack_require__(25158);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/PushpinOutlined.js + 1 modules
var PushpinOutlined = __webpack_require__(10683);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/GlobalOutlined.js + 1 modules
var GlobalOutlined = __webpack_require__(89210);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/LineOutlined.js + 1 modules
var LineOutlined = __webpack_require__(83755);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/UngroupOutlined.js + 1 modules
var UngroupOutlined = __webpack_require__(61579);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/UserOutlined.js + 1 modules
var UserOutlined = __webpack_require__(24994);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/TagOutlined.js + 1 modules
var TagOutlined = __webpack_require__(93414);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/FontColorsOutlined.js + 1 modules
var FontColorsOutlined = __webpack_require__(91554);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js + 1 modules
var QuestionCircleOutlined = __webpack_require__(77138);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/HistoryOutlined.js + 1 modules
var HistoryOutlined = __webpack_require__(25118);
// EXTERNAL MODULE: ../../node_modules/@ant-design/icons/es/icons/UnorderedListOutlined.js + 1 modules
var UnorderedListOutlined = __webpack_require__(50845);
// EXTERNAL MODULE: ../../node_modules/antd/es/menu/index.js + 10 modules
var menu = __webpack_require__(36374);
// EXTERNAL MODULE: ../../node_modules/next/config.js
var config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/common/components/AppLayout/Sider/index.tsx











const Sider = ()=>{
    const { pathname  } = (0,router.useRouter)();
    const { t  } = (0,useTranslation/* default */.Z)("admin");
    const { t: tcommon  } = (0,useTranslation/* default */.Z)("common");
    const { publicRuntimeConfig  } = config_default()();
    const { data  } = (0,useQuery/* useQuery */.a)(src/* GET_ME */.xFT);
    const { data: channelData  } = (0,useQuery/* useQuery */.a)(src/* GET_CHANNELS */.Ev$);
    const isIdeaAssigned = (channelData === null || channelData === void 0 ? void 0 : channelData.channels.filter((item)=>item.ideasCount).length) > 0;
    const menuItems = [
        {
            key: "dashboard",
            link: "/",
            label: t("dashboard"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardOutlined/* default */.Z, {}),
            roles: [
                "ADMIN"
            ]
        },
        {
            key: "idea-hub",
            link: "/idea-hub",
            label: t("idea_hub"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockOutlined/* default */.Z, {}),
            roles: [
                "ADMIN"
            ],
            permissions: isIdeaAssigned ? [
                src/* PERMISSIONS.ADMIN */._IT.ADMIN,
                src/* PERMISSIONS.INTERNAL_CHALLENGE_MANAGEMENT */._IT.INTERNAL_CHALLENGE_MANAGEMENT,
                src/* PERMISSIONS.OPEN_CHALLENGE_MANAGEMENT */._IT.OPEN_CHALLENGE_MANAGEMENT
            ] : [
                src/* PERMISSIONS.ADMIN */._IT.ADMIN,
                src/* PERMISSIONS.INTERNAL_CHALLENGE_MANAGEMENT */._IT.INTERNAL_CHALLENGE_MANAGEMENT
            ]
        },
        {
            key: "content-group",
            label: t("contents"),
            roles: [
                "ADMIN"
            ],
            type: "group",
            children: [
                {
                    key: "content-management",
                    link: "/content-management",
                    label: t("posts_and_events"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                },
                {
                    key: "sidebar-management",
                    link: "/sidebar-management",
                    label: t("sidebar"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PushpinOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                }
            ]
        },
        {
            key: "challenge-group",
            label: t("challenges"),
            roles: [
                "ADMIN"
            ],
            type: "group",
            permissions: [
                src/* PERMISSIONS.COMMUNITY_MANAGER */._IT.COMMUNITY_MANAGER,
                src/* PERMISSIONS.OPEN_CHALLENGE_MANAGEMENT */._IT.OPEN_CHALLENGE_MANAGEMENT,
                src/* PERMISSIONS.INTERNAL_CHALLENGE_MANAGEMENT */._IT.INTERNAL_CHALLENGE_MANAGEMENT
            ],
            children: [
                {
                    key: "open-innovation",
                    label: t("open_innovation"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ],
                    permissions: [
                        src/* PERMISSIONS.COMMUNITY_MANAGER */._IT.COMMUNITY_MANAGER,
                        src/* PERMISSIONS.OPEN_CHALLENGE_MANAGEMENT */._IT.OPEN_CHALLENGE_MANAGEMENT
                    ],
                    children: [
                        {
                            key: "open-challenges",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineOutlined/* default */.Z, {}),
                            link: "/entrepreneurship/challenge",
                            label: t("open_challenges"),
                            roles: [
                                "ADMIN"
                            ],
                            permissions: [
                                src/* PERMISSIONS.OPEN_CHALLENGE_MANAGEMENT */._IT.OPEN_CHALLENGE_MANAGEMENT
                            ]
                        },
                        {
                            key: "community",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineOutlined/* default */.Z, {}),
                            link: "/community",
                            label: t("community"),
                            roles: [
                                "ADMIN"
                            ],
                            permissions: [
                                src/* PERMISSIONS.COMMUNITY_MANAGER */._IT.COMMUNITY_MANAGER
                            ]
                        }
                    ]
                },
                {
                    key: "intra-challenges",
                    link: "/intrapreneurship/challenge",
                    label: t("intra_challenges"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FireOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ],
                    permissions: [
                        src/* PERMISSIONS.INTERNAL_CHALLENGE_MANAGEMENT */._IT.INTERNAL_CHALLENGE_MANAGEMENT
                    ]
                },
                {
                    key: "space-management",
                    link: "/space-management",
                    label: t("spaces"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UngroupOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                },
                {
                    key: "idea-management",
                    link: "/idea-management",
                    label: t("ideas"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BulbOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                }
            ]
        },
        {
            key: "manage-group",
            label: t("manage"),
            roles: [
                "ADMIN"
            ],
            type: "group",
            permissions: [
                src/* PERMISSIONS.A3_MANAGER */._IT.A3_MANAGER,
                src/* PERMISSIONS.COMMUNITY_MANAGER */._IT.COMMUNITY_MANAGER
            ],
            children: [
                {
                    key: "user-management",
                    link: "/user-management",
                    label: t("users"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ],
                    permissions: [
                        src/* PERMISSIONS.A3_MANAGER */._IT.A3_MANAGER
                    ]
                },
                {
                    key: "company-management",
                    link: "/company-management",
                    label: t("companies"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                },
                {
                    key: "tags",
                    link: "/tag-management",
                    label: tcommon("tags"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                },
                {
                    key: "topics",
                    link: "/topic-management",
                    label: tcommon("topics"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FontColorsOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                },
                {
                    key: "pitch-management",
                    link: "/pitch-management",
                    label: t("pitch_videos"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCameraOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                },
                // {
                //   key: 'announcement',
                //   link: '/announcement',
                //   label: t('announcement'),
                //   icon: <MailOutlined />,
                //   roles: ['ADMIN'],
                //   permissions: [PERMISSIONS.COMMUNITY_MANAGER],
                // },
                {
                    key: "proof-of-concept",
                    link: "/proof-of-concept",
                    label: t("proof_of_concept"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeSandboxOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                },
                {
                    key: "survey",
                    link: "/survey",
                    label: t("surveys"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionCircleOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ],
                    permissions: [
                        src/* PERMISSIONS.COMMUNITY_MANAGER */._IT.COMMUNITY_MANAGER
                    ]
                },
                {
                    key: "help-desk",
                    link: "/guide",
                    label: t("help_desk"),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryOutlined/* default */.Z, {}),
                    roles: [
                        "ADMIN"
                    ]
                }
            ]
        }
    ];
    const addLinkLabel = (item)=>{
        if (item.link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: item.link,
                children: item.label
            });
        }
        return item.label;
    };
    const filteredItems = (data === null || data === void 0 ? void 0 : data.me) ? menuItems.map((item)=>{
        if (item.type === "group") {
            var ref;
            const children = (ref = item.children) === null || ref === void 0 ? void 0 : ref.filter((child)=>child.roles.includes(data.me.role) || (0,src/* checkPermission */.P_w)(data.me, child.permissions)).map((child)=>({
                    ...child,
                    label: addLinkLabel(child),
                    children: child.children ? child.children.filter((subChild)=>subChild.roles.includes(data.me.role) || (0,src/* checkPermission */.P_w)(data.me, subChild.permissions)).map((subChild)=>({
                            ...subChild,
                            label: addLinkLabel(subChild)
                        })) : undefined
                }));
            return children && children.length ? {
                ...item,
                children
            } : null;
        }
        return {
            ...item,
            label: addLinkLabel(item)
        };
    }).filter((item)=>item && (item.roles.includes(data.me.role) || (0,src/* checkPermission */.P_w)(data.me, item.permissions))) : [];
    // Find the first available key, looking inside children if necessary
    const findActiveKey = (items)=>{
        for (const item of items){
            if (item.link === pathname) return item.key;
            if (item.children && item.children.length) {
                const childKey = findActiveKey(item.children);
                if (childKey) return childKey;
            }
        }
        return undefined;
    };
    const [page, setPage] = (0,react.useState)(findActiveKey(filteredItems));
    (0,react.useEffect)(()=>{
        setPage(findActiveKey(filteredItems));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    const siderStyle = {
        height: "100vh",
        position: "sticky",
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: "thin",
        scrollbarGutter: "stable"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default.Sider */.Z.Sider, {
        width: 230,
        collapsedWidth: 60,
        breakpoint: "lg",
        style: siderStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 pt-3 pb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "".concat(publicRuntimeConfig.staticFolder, "/logo-full.svg"),
                        priority: true,
                        height: "40",
                        width: "166",
                        alt: tcommon("scv_logo")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-[calc(100vh-64px)] admin-sidebar-menu flex flex-col justify-between overflow-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                        mode: "inline",
                        selectedKeys: [
                            page
                        ],
                        defaultOpenKeys: (pathname === null || pathname === void 0 ? void 0 : pathname.startsWith("/entrepreneurship")) ? [
                            "entrepreneurship"
                        ] : (pathname === null || pathname === void 0 ? void 0 : pathname.startsWith("/intrapreneurship")) ? [
                            "intrapreneurship"
                        ] : [],
                        style: {
                            borderRight: 0
                        },
                        items: filteredItems
                    }),
                    (0,src/* checkPermission */.P_w)(data.me, [
                        src/* PERMISSIONS.ADMIN */._IT.ADMIN
                    ]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                            mode: "inline",
                            selectedKeys: pathname.includes("audit-log") ? [
                                "audit-log"
                            ] : [],
                            style: {
                                borderRight: 0
                            },
                            items: [
                                {
                                    key: "audit-log",
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/audit-log",
                                        children: t("audit_log")
                                    }),
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnorderedListOutlined/* default */.Z, {})
                                }
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AppLayout_Sider = (Sider);

;// CONCATENATED MODULE: ./src/common/components/AppLayout/index.tsx





const { Content  } = layout/* default */.Z;
const AppLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        style: {
            minHeight: "100vh"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout_Sider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout_Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        className: "p-6 mt-0 mx-6 mb-6 bg-white border-solid border border-gray-400 rounded-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto",
                            children: children
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_AppLayout = (AppLayout);


/***/ }),

/***/ 80348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SE": function() { return /* reexport */ selectFirebaseUUID; },
  "zc": function() { return /* reexport */ userSlice/* setFirebaseUUID */.zc; }
});

// UNUSED EXPORTS: initialState

;// CONCATENATED MODULE: ./src/features/user/selectors.ts
const selectFirebaseUUID = (state)=>state.user.firebaseUUID;

// EXTERNAL MODULE: ./src/features/user/userSlice.ts
var userSlice = __webpack_require__(36865);
;// CONCATENATED MODULE: ./src/features/user/index.ts




/***/ }),

/***/ 3058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ useAppSelector; },
/* harmony export */   "D9": function() { return /* binding */ usePrevious; },
/* harmony export */   "TL": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43997);


/* eslint-disable @typescript-eslint/no-explicit-any */ const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
const useAppDispatch = react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0;
const useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9;


/***/ })

}]);